import { useSafeApiOrgSlug, useApiQuery } from '@joyful/ui/app'
import { formatNumber } from '@joyful/utils'

const NEEDS_RESPONSE_COUNT_REFETCH_INTERVAL_MS = 60_000

/** Polls OPEN practice requests that need a response from the caller. */
export function useNeedsResponsePracticeRequestsCount() {
  const orgSlug = useSafeApiOrgSlug()
  const shouldFetchNeedsResponseCount = orgSlug !== null

  const needsResponseCountQuery = useApiQuery(
    'get',
    '/{org_slug}/requests/pending_response_count',
    {
      params: { path: { org_slug: orgSlug ?? '' } },
    },
    {
      enabled: shouldFetchNeedsResponseCount,
      refetchInterval: NEEDS_RESPONSE_COUNT_REFETCH_INTERVAL_MS,
      refetchOnWindowFocus: false,
    },
  )

  const needsResponseCount = needsResponseCountQuery.isSuccess
    ? needsResponseCountQuery.data.pending_response_count
    : 0
  const formattedNeedsResponseCount =
    needsResponseCount > 10 ? `10+` : formatNumber(needsResponseCount)

  return { formattedNeedsResponseCount, needsResponseCount }
}
